import { Network, MessageCircle, Calendar, Users } from "lucide-react";

const Diagrams = () => {
  return (
    <section className="py-24 px-6 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-accent/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 border border-accent/20 mb-6">
              <Network className="w-4 h-4 text-accent" />
              <span className="text-sm font-medium text-accent">Connected</span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-serif font-semibold text-foreground mb-6">
              See your community thrive
            </h2>
            
            <p className="text-muted-foreground text-lg">
              Watch Concierge manage your bookings, workspace support, and community connections. With 24/7 assistance, you’re free to focus on your best work and get the most out of Kiln.
            </p>
          </div>

          {/* Diagram illustration */}
          <div className="relative">
            <DiagramVisualization />
          </div>
        </div>
      </div>
    </section>
  );
};

const DiagramVisualization = () => {
  const nodes = [
    { icon: MessageCircle, label: "Chat", x: 41, y: 20 },
    { icon: Calendar, label: "Events", x: 15, y: 60 },
    { icon: Users, label: "Members", x: 63, y: 60 },
  ];

  return (
    <div className="relative h-80 landing-glass rounded-2xl p-8 landing-glow-accent">
      {/* Connection lines */}
      <svg className="absolute inset-0 w-full h-full" style={{ zIndex: 0 }}>
        <defs>
          <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(var(--primary))" stopOpacity="0.5" />
            <stop offset="100%" stopColor="hsl(var(--accent))" stopOpacity="0.5" />
          </linearGradient>
        </defs>
        <line x1="50%" y1="35%" x2="25%" y2="65%" stroke="url(#lineGradient)" strokeWidth="2" />
        <line x1="50%" y1="35%" x2="75%" y2="65%" stroke="url(#lineGradient)" strokeWidth="2" />
        <line x1="25%" y1="65%" x2="75%" y2="65%" stroke="url(#lineGradient)" strokeWidth="2" strokeDasharray="4" />
      </svg>

      {/* Nodes */}
      {nodes.map((node, index) => {
        const Icon = node.icon;
        return (
          <div
            key={node.label}
            className="absolute landing-glass rounded-lg p-4 flex flex-col items-center gap-2 animate-float"
            style={{
              left: `${node.x}%`,
              top: `${node.y}%`,
              transform: 'translate(-50%, -50%)',
              animationDelay: `${index * 0.3}s`,
            }}
          >
            <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center">
              <Icon className="w-5 h-5 text-primary" />
            </div>
            <span className="text-xs font-medium text-muted-foreground">{node.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default Diagrams;
